<template>
  <div class="">
    <div class="tableDiv">
      <div class="table-header"><img class="tableimg" src="img/diseblue1.gif" /><span class="tableheading">PendPR (5/8)</span> </div>
      <b-table striped hover :items="PendPR"></b-table>
      <span class="page"><span style="color:blue; margin-right: 5px;">1</span> 2</span>
    </div>

    <div class="tableDiv">
      <div class="table-header"><img class="tableimg" src="img/diseblue1.gif" /><span class="tableheading">aaa (5/8)</span> </div>
      <b-table striped hover :items="aaa"></b-table>
      <span class="page"><span style="color:blue; margin-right: 5px;">1</span> 2</span>
    </div>

    <div class="tableDiv">
      <div class="table-header"><img class="tableimg" src="img/diseblue1.gif" /><span class="tableheading">VenFil (5/8)</span> </div>
      <b-table striped hover :items="ven"></b-table>
    </div>

    <div class="tableDiv">
      <div class="table-header"><img class="tableimg" src="img/diseblue1.gif" /><span class="tableheading">CRejYes (5/8)</span> </div>
      <b-table striped hover :items="rej"></b-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Transaction',
  data() {
      return {
        PendPR: [
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/051/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0512/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/052/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '11', Authorized: 'Yes', Authorization_Stage: '3' },
        ],
        aaa: [
          { Blanket_Po_No: 'BPO/05/1/2020', Blanket_Po_Date: '2020-06-19 00:00:00.000', Vendor_Code: 'V001', Effective_Date: '2020-06-19 00:00:00.000', Expiry_Date: '2030-02-11 00:00:00.000', Payment_Terms_Code: 'P001' },
          { Blanket_Po_No: 'BPO/05/1/2020', Blanket_Po_Date: '2020-06-19 00:00:00.000', Vendor_Code: 'V001', Effective_Date: '2020-06-19 00:00:00.000', Expiry_Date: '2030-02-11 00:00:00.000', Payment_Terms_Code: 'P001' },
          { Blanket_Po_No: 'BPO/05/6/2020', Blanket_Po_Date: '2020-06-19 00:00:00.000', Vendor_Code: 'V001', Effective_Date: '2020-06-19 00:00:00.000', Expiry_Date: '2030-02-11 00:00:00.000', Payment_Terms_Code: 'P001' },
          { Blanket_Po_No: 'BPO/05/6/2020', Blanket_Po_Date: '2020-06-19 00:00:00.000', Vendor_Code: 'V001', Effective_Date: '2020-06-19 00:00:00.000', Expiry_Date: '2030-02-11 00:00:00.000', Payment_Terms_Code: 'P001' },
          { Blanket_Po_No: 'BPO/05/7/2020', Blanket_Po_Date: '2020-06-19 00:00:00.000', Vendor_Code: 'V001', Effective_Date: '2020-06-19 00:00:00.000', Expiry_Date: '2030-02-11 00:00:00.000', Payment_Terms_Code: 'P001' },
        ],
        ven: [
          { Vendor_Code: 'V001', Vendor_Name: 'ALEX', Vendor_Acc_Id: '10053', Currency_Code: 'Dollar', Payment_Terms_Code: 'P001', Shipment_Mode_Code: 'S1' },
        ],
        rej: [
          { Pur_Requisition_No: 'PR/0513/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'No', Authorization_Stage: '0' },
          { Pur_Requisition_No: 'PR/0517/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0518/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0519/2020', Pur_Requisition_Date: '2020-06-22 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '0', Authorized: 'Yes', Authorization_Stage: '3' },
          { Pur_Requisition_No: 'PR/0520/2020', Pur_Requisition_Date: '2020-06-19 00:00:00.000', Pur_Requisition_Type: 'Manual', Ref_No: '11', Authorized: 'Yes', Authorization_Stage: '3' },
        ]
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tableDiv{
  border: 1px solid;
  margin: 20px 0px 15px 5px;
  border-radius: 5px;
  text-align: left;
}
.table-header{
  background: #bdc7d6;
  text-align: left;
  border-bottom: 1px solid;
}
.tableimg{
  padding-left: 10px;
    padding-right: 10px;
    width: 30px;
    margin-top: -4px;
}
.tableheading{
      font-size: 14px;
    font-weight: 700;
}
.page{
  padding-top: 5px !important;
  padding-left: 15px !important;
   font-weight:500;
    font-size: 12px;
}
</style>
